// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1___f9b94f2e0ee8fd363e6","cls2":"Header-cls2___65c0eaae78271ae6744 Header-cls1___f9b94f2e0ee8fd363e6"};